import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="footer">
    <div>
      <h3>Sprout Academy</h3>
      <p>Learning through adventure.</p>
    </div>
    <div className="footer__links">
      <Link to="/">Home</Link>
      <Link to="/about">About us</Link>
      <Link to="/curriculum">Explore curriculum</Link>
      <Link to="/roadmap">Public roadmap</Link>
    </div>
  </footer>
);

export default Footer;
